export const IS_TEST_ENV = process.env.VITEST !== undefined;
export const IS_CI_ENV = process.env.CI !== undefined;

export const FORM_SORT_ANSWERS_COOKIE_KEY = 'formSortAnswers';

export const ONE_WEEK_TO_DAYS = 7;
export const ONE_DAY_TO_HOURS = 24;
export const ONE_HOUR_TO_MINUTES = 60;
export const ONE_MINUTE_TO_SECONDS = 60;
export const SECONDS_TO_MILLISECONDS = 1000;
